export const tripShareEn = {
  shareTrip: 'Share trip',
  peopleWithAccess: 'People with access',
  invite: 'Invite',
  sendInvite: 'Send invite',
  role: 'Role',
  editor: 'Editor',
  viewer: 'Viewer',
  pending: 'Pending',
  active: 'Active',
  revoked: 'Revoked',
  members: 'Members',
  emptyRoster: 'No members yet. Invite a connection to share this trip.',
  changeRole: 'Change role',
  remove: 'Remove',
  inboxTitle: 'Trip invitations',
  inboxEmpty: 'When someone shares a trip with you, it will appear here.',
  pendingSection: 'Pending',
  sharedWithMe: 'Shared with me',
  accept: 'Accept',
  decline: 'Decline',
  leave: 'Leave trip',
  from: 'From',
  unnamedTrip: 'Shared trip',
  memberCap: 'This trip already has the maximum number of members (20).',
  invitationUnavailable: 'This invitation is no longer available',
  readOnlyBanner: 'View only — you can browse this trip but not edit it.',
  attachmentOwnerOnly: 'Only the trip owner can open attachments',
  sharedBadge: 'Shared',
  loading: 'Loading…',
  retry: 'Retry',
  accepted: 'Trip invitation accepted',
  inviteSent: 'Invitation sent',
  left: 'You left the shared trip',
  openInbox: 'Trip invitations',
} as const;
